import type { MacroMeasurementUnit, MicroMeasurementUnit } from 'typings/unitTypes'

export const measurementUnitMap = new Map<MicroMeasurementUnit | '', MacroMeasurementUnit | ''>([
  ['gr', 'kg'],
  ['ml', 'l']
])
